import { Box, Typography, Avatar, Button, Card } from '@mui/material';

interface StatCardProps {
    title: string;
    subtitle: string;
    value: number | string;
    bgColor: string;
    textColor: string;
    icon?: React.ReactNode;
    onClick?: () => void;
}

const StatCard = ({
    title,
    subtitle,
    value,
    icon,
    bgColor,
    textColor,
    onClick,
}: StatCardProps) => {
    return (
        <Card
            elevation={0}
            sx={{
                borderRadius: 4,
                p: 3,
                backgroundColor: '#fff',
                boxShadow: '0px 4px 20px rgba(0,0,0,0.05)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                width: '100%',
                height: 180,
            }}
        >
            {/* Top section: Title + subtitle + icon */}
            <Box display="flex" justifyContent="space-between" alignItems="start">
                <Box>
                    <Typography variant="subtitle1" fontWeight={600}>
                        {title}
                    </Typography>
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'visible',
                            textOverflow: 'unset',
                            whiteSpace: 'normal',
                            minHeight: '4rem',
                        }}
                    >
                        {subtitle}
                    </Typography>
                </Box>

                <Avatar
                    sx={{
                        bgcolor: bgColor,
                        color: textColor,
                        width: 40,
                        height: 40
                    }}
                >
                    {icon}
                </Avatar>
            </Box>

            {/* Bottom section: value + button */}
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                flexWrap="wrap"
                rowGap={1}
                mt="auto"
            >
                <Typography
                    variant="h4"
                    fontWeight="bold"
                    sx={{ fontSize: { xs: '32px', sm: '40px' }, lineHeight: 1 }}
                >
                    {value}
                </Typography>
                <Button
                    size="small"
                    variant="contained"
                    onClick={onClick}
                    sx={{
                        whiteSpace: 'nowrap',
                        minWidth: 'auto',
                        px: 1.5,
                        py: 0.5,
                        height: 24,
                        borderRadius: 999,
                        backgroundColor: bgColor,
                        color: textColor,
                        fontSize: '12px',
                        fontWeight: 500,
                        textTransform: 'none',
                        boxShadow: 'none',
                        '&:hover': {
                            backgroundColor: '#D1F2E3',
                            boxShadow: 'none',
                        },
                    }}
                >
                    view more
                </Button>
            </Box>
        </Card>
    );
};

export default StatCard;
